module.exports = __webpack_public_path__ + "static/media/air-conditioner-close.02dc0af6.png";